/**
 * ui.tsx — tiny shared primitives for Calculator Studio editors.
 * Inline styles + CSS variables only (no `primary`-named Tailwind classes).
 */

import type { CSSProperties, ReactNode } from 'react';

export const card: CSSProperties = {
  background: 'var(--card, #fff)',
  border: '1px solid var(--line, #e5e7eb)',
  borderRadius: 10,
  overflow: 'hidden',
};

export const field: CSSProperties = {
  height: 32,
  padding: '0 10px',
  border: '1px solid var(--line, #e5e7eb)',
  borderRadius: 7,
  background: 'var(--card, #fff)',
  fontSize: 13,
  color: 'var(--ink-1, #1f2937)',
  boxSizing: 'border-box',
};

export const btn: CSSProperties = {
  height: 30,
  padding: '0 12px',
  border: '1px solid var(--line, #e5e7eb)',
  borderRadius: 7,
  background: 'var(--card, #fff)',
  cursor: 'pointer',
  fontSize: 13,
  color: 'var(--ink-1, #1f2937)',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
};

export const btnAccent: CSSProperties = {
  ...btn,
  background: 'var(--accent, #4f46e5)',
  color: '#fff',
  border: '1px solid var(--accent, #4f46e5)',
};

export const btnGhostDanger: CSSProperties = {
  ...btn,
  height: 28,
  padding: '0 8px',
  color: 'var(--danger, #dc2626)',
};

export const label: CSSProperties = {
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: 0.3,
  textTransform: 'uppercase',
  color: 'var(--ink-3, #6b7280)',
  marginBottom: 4,
  display: 'block',
};

export function StudioPanel({
  title,
  subtitle,
  right,
  children,
  icon,
}: {
  title: string;
  subtitle?: string;
  right?: ReactNode;
  icon?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div style={{ ...card, marginBottom: 14 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '10px 14px',
          borderBottom: '1px solid var(--line, #e5e7eb)',
          background: 'var(--bg-1, #f8f9fa)',
        }}
      >
        {icon}
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 13.5, fontWeight: 700, color: 'var(--ink-1, #1f2937)' }}>{title}</div>
          {subtitle && <div style={{ fontSize: 11.5, color: 'var(--ink-3, #6b7280)' }}>{subtitle}</div>}
        </div>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: 6 }}>{right}</div>
      </div>
      <div style={{ padding: 14 }}>{children}</div>
    </div>
  );
}
